export const requiredValidatorKey = 'required';
export const requiredValidator = (value) => {
    const isValid = !!value && value.length > 0;
    return {
        [requiredValidatorKey]: isValid,
    };
};
//# sourceMappingURL=required.validator.js.map